import "./less/logger.less";
import "./css/custom.css";

import {csrfSafeMethod, crossDomainRequest} from "./js/csrf";


import Vue from "vue"
import Raven from 'raven-js';
import VueCookie from "vue-cookie"
import VueRouter from "vue-router"
import VueResource from "vue-resource"
import RavenVue from 'raven-js/plugins/vue';

import {mapGetters} from "vuex"

import * as uiv from "uiv"

import Toast from "./vue/Toast.vue"

import Login from "./vue/logger/Login.vue"
import Logger from "./vue/logger/Logger.vue"
import JobPost from "./vue/logger/JobPost.vue"
import Privacy from "./vue/logger/Privacy.vue"
import StoreList from "./vue/logger/StoreList.vue"
import StoreJobs from "./vue/logger/StoreJobs.vue"
import JobReview from "./vue/logger/JobReview.vue"
import JobUrgency from "./vue/logger/JobUrgency.vue"
import LoggerNavbar from "./vue/logger/LoggerNavbar.vue"
import ResetRequest from "./vue/logger/ResetRequest.vue"
import PasswordReset from "./vue/logger/PasswordReset.vue"

import includes from "lodash/includes"

if (process.env.RAVEN_PUBLIC) {
  Raven
    .config(process.env.RAVEN_PUBLIC)
    .addPlugin(RavenVue, Vue)
    .install();
}

Vue.use(uiv);
Vue.use(VueCookie);
Vue.use(VueRouter);
Vue.use(VueResource);

import store from "./js/store"

const routes = [
  {
    path: "/stores",
    component: StoreList,
    name: "store-list"
  },
  {
    path: "/jobs/store/:store_id",
    component: StoreJobs,
    name: "store-jobs"
  },
  {
    path: "/job/:job_id",
    component: Logger,
    name: "job-logger"
  },
  {
    path: "/job/:job_id/urgency",
    component: JobUrgency,
    name: "job-urgency"
  },
  {
    path: "/job/:job_id/review",
    component: JobReview,
    name: "job-review"
  },
  {
    path: "/job/:job_id/post",
    component: JobPost,
    name: "job-post"
  },
  {
    path: "/login",
    component: Login,
    name: "login"
  },
  {
    path: "/forgotpassword",
    component: ResetRequest,
    name: "reset-request",
  },
  {
    path: "/reset/:reset_id",
    component: PasswordReset,
    name: "password-reset",
  },
  {
    path: "/privacy",
    component: Privacy,
    name: "privacy-policy",
  },
  {
    path: "*",
    redirect: "/stores",
  }
];

const router = new VueRouter({
  routes
});

Vue.http.interceptors.push((request, next) => {
  // Check if we need to set the header
  if(!csrfSafeMethod(request.method) && !crossDomainRequest(request.url)) {
    request.headers.set("X-CSRFToken", Vue.cookie.get("csrftoken"));
  }
  next();
});

new Vue({
  el: "#root",
  router,
  store,
  async created () {
    await this.$store.dispatch("get_user_info");
    if (!this.$store.state.user.authed) {
      if (!includes([
          "login",
          "reset-request",
          "password-reset",
          "privacy-policy"
        ], this.$route.name)){
        this.$router.push({name: "login"});
      }
    }
  },
  computed: mapGetters(["logged_in", "toasts"]),
  methods: {
    toast_closed(toast) {
      this.$store.commit("remove_toast", toast.id);
    },
  },
  watch: {
    logged_in(val) {
      if (val) {
        this.$store.dispatch("get_issue_types");
      }
    }
  },
  components: {
    LoggerNavbar,
    Toast,
  }
});



// WEBPACK FOOTER //
// ./assets/index.js